import React from "react";
import './sass/style.css'
const loadingCard = () => {
  return(
    <div className="loading-card" >
      <div className="image"></div>
      <div className="content">
        <h2></h2>
        <p></p>
        <p></p>
        <p></p>
      </div>
    </div>
  )
}

export default loadingCard;